import { Space, Typography } from 'antd';

const { Text } = Typography;

function InfoBanner({ label, info }) {
  return (
    <Space className="info-banner" direction="vertical">
      <Text strong>{label}</Text>
      <Text>{info}</Text>
    </Space>
  );
}

export default InfoBanner;
